import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import ConfigProvider from '../config-provider';
import { obj } from '../util';

class Img extends React.Component {
  static propTypes = {
    prefix: PropTypes.string,
    className: PropTypes.string,
    src: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['xs', 'small', 'medium', 'large', 'xl']),
  }

  static defaultProps = {
    prefix: 'next-',
    size: 'medium',
  }

  render() {
    const { prefix, className, src, size, ...others } = this.props;
    const classNames = cls({
      [`${prefix}cover-img`]: true,
      [`${prefix}cover-img-${size}`]: true,
      [className]: !!className,
    });
    return (
      <div className={classNames} {...obj.pickAttrs(others)}>
        <img src={src} />
      </div>
    );
  }
}

const Configured = ConfigProvider.config(Img);
Configured.displayName = 'Img';

export default Configured;
